module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_5.2ca393d7.png";